const authorFromScratch = {
  topicId: "nualang.author-from-scratch.0.0.1",
  topicName: "Erstelle dein eigenes",
  description: "",
  difficulty: "ALL",
  learnLang: "german",
};

export default authorFromScratch;
